import React from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import { useMessage } from '../../hooks/useMessage';
import { usePromoCart } from '../../hooks/usePromoCart';
import { usePromoModel } from '../../hooks/usePromoModel';
import { MESSAGE_KEY } from '../../utils/constants';

export const ShopAllButton = () => {
  const { refinedFpnUri, refinedCategoriesFpnUri } = usePromoModel();
  const { selectedItemsModel } = usePromoCart();
  const buttonText = useMessage(
    refinedCategoriesFpnUri ? MESSAGE_KEY.shopAllButtonCategory : MESSAGE_KEY.shopAllButton,
    !refinedCategoriesFpnUri && selectedItemsModel.length
  );
  const fpnUri = refinedCategoriesFpnUri || refinedFpnUri;

  return (
    <Button
      fullWidth
      href={fpnUri}
      variant="secondary"
      data-testid="shop-all-button"
    >
      {buttonText}
    </Button>
  );
};

ShopAllButton.displayName = 'ShopAllButton';
